<div class="overflow-y-auto h-[85vh] mx-5 mb-5 pr-5 mr-0 overflow-x-hidden font-poppins">

	<div class="bg-white rounded-2xl ">
		<span class="join gap-2 relative w-full">
			<app-dashboard-page-header [platformName]="'linkedin'"  (selectedDateRange)="updateStats($event)" [hasNoPages]="linkedinPageIds.length==0 &&  !isInsightsLoading" />
			
		</span>
	</div>

	<div class=" bg-white my-5 py-2 rounded-xl p-5">
			<h3 class="font-bold py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading && linkedinPageIds.length>0}">{{'pageInsights.labels.general'|translate}}</h3>
			<div class="flex flext-wrap gap-2 w-[100%] pb-3" >
				<app-widget-stats *ngFor="let item of GetGeneralData()" class=" w-[20%] " [data]="item" [source]="'linkedin'" [isLoading]="isInsightsLoading && linkedinPageIds.length>0" />
			
			</div>
	</div>
	
	<div class="bg-white my-5 py-2 rounded-xl p-5">
			<h3 class="font-bold py-4 text-xl" [ngClass]="{'animate-pulse':isInsightsLoading && linkedinPageIds.length>0}">{{'pageInsights.labels.visibility'|translate}}</h3>
			<div class="flex flext-wrap gap-2 w-full pb-3" >	
				<app-widget-stats *ngFor="let item of GetVisibilityData()" class=" w-[33.33%] " [data]="item" [source]="'linkedin'" [isLoading]="isInsightsLoading && linkedinPageIds.length>0"/>
			</div>
	</div>

	<div class=" bg-white my-5 py-2 rounded-xl  p-5"  [ngClass]="{'animate-pulse':isInsightsLoading && linkedinPageIds.length>0}">
			<h3 class="font-bold py-4 text-xl">{{'pageInsights.labels.indicators'|translate}}</h3>
			<div class="flex flext-wrap gap-2 w-full pb-3" >	
				<app-widget-stats *ngFor="let item of GetIndicatorsData()" class=" w-[25%] "  [data]="item" [source]="'linkedin'" [isLoading]="isInsightsLoading && linkedinPageIds.length>0"/>
			</div>
	</div>

	<!-- <div class="join gap-2 w-full mb-5">
		<div class="w-1/2 bg-white py-2 rounded-xl p-5" [ngClass]="{'animate-pulse':isInsightsLoading}">
			<h3 class="font-bold ml-5 py-4 text-xl">{{'Vidéo'|translate}}</h3>
			<div class="flex flext-wrap gap-2 w-full pb-3" >	
				<app-widget-stats *ngFor="let item of GetVideoData()" class=" w-[50%] "  [data]="item" [source]="'linkedin'" [isLoading]="isInsightsLoading" />
			</div>
		</div>
		<div class="w-1/2 bg-white py-2 rounded-xl p-5" [ngClass]="{'animate-pulse':isInsightsLoading}">
			<h3 class="font-bold ml-5 py-4 text-xl">{{'Publicité'|translate}}</h3>
			<div class="flex flext-wrap gap-2 w-full pb-3" >	
				<app-widget-stats *ngFor="let item of GetAdsData()" class=" w-[50%] "  [data]="item" [source]="'linkedin'" [isLoading]="isInsightsLoading"/>
			</div>
		</div>
	</div> -->

	<!-- delete this part -->
	 <div *ngIf="linkedinPageIds.length>0" class="bg-white h-[82vh] my-5 py-5 relative flex items-end rounded-2xl">
		 <div class="rounded-2xl h-[80vh] overflow-hidden absolute w-full">
			 <app-posts-library  [dashboard]="true" [dashboardSource]="'linkedin'" [currentPostsTypeFilter]="{isPosted:true,isPlanned:true}" [dateRange]="period" [currentPlaTformsFilters]= "{isFacebookON: false, isLinkedinON: true, isGoogleON: false, isInstagramON: false}"/>
		 </div>
	 </div>
	<!-- end delete -->
</div>

